module.exports = __webpack_public_path__ + "img/Ardunic Account page-333.ab14d121.svg";